import { noop } from 'mojito/utils';
import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import KeypadImageButton from './keypad-image-button.js';

const UIView = MojitoCore.Presentation.UIView;

/**
 * KeypadImageButton view that renders a button with an image, used in keypads.
 *
 * @class KeypadImageButton
 * @memberof Mojito.Modules.Keypad.NumericKeypad
 */

/**
 * Callback for keypad button click events.
 *
 * @param {object} data - Information about the clicked button.
 * @callback Mojito.Modules.Keypad.NumericKeypad.KeypadImageButton.onClick
 */

/**
 * `KeypadImageButton` prop types.
 *
 * @property {*} [onClickData] - Data to be passed to the onClick handler.
 * @property {Mojito.Modules.Keypad.NumericKeypad.KeypadImageButton.onClick} [onClick = () => {}] - Callback function triggered when a keypad button is tapped.
 * @property {string} [class] - The className to be assigned to the Button element.
 * @memberof Mojito.Modules.Keypad.NumericKeypad.KeypadImageButton
 */

const propTypes = {
    onClick: PropTypes.func,
    onClickData: PropTypes.object,
    class: PropTypes.string,
};

const defaultPropTypes = {
    onClick: noop,
};

export default UIView('KeypadImageButton', KeypadImageButton, propTypes, defaultPropTypes);
